import { Pipe, PipeTransform } from '@angular/core';
import { FiltersLocation, FiltersRegion } from '../../interfaces/region.interface';

@Pipe({
  name: 'locationsFilterPipe',
  standalone: true
})
export class LocationsFilterPipe implements PipeTransform {

  transform(value: FiltersLocation[], regions: FiltersRegion[]): FiltersLocation[] {
    let finalLocations: FiltersLocation[] = [];
    finalLocations = value.filter(l => regions.some(r => r.id === l.regionId));
    return finalLocations;
  }

}
